module.exports = __webpack_public_path__ + "static/a-virus-hits-home-520a66f2144e5151dbfefeb4cc55cff1.jpg";